import { useTranslation } from 'react-i18next'
import { MemoContainer, MemoValue, MemoWarning } from './DepositInfo.styled'

interface MemoInfoProps {
  memo: string
}

export const MemoInfo = ({ memo }: MemoInfoProps) => {
  const { t } = useTranslation()

  return (
    <>
      <MemoContainer>
        <span>{t('wallet.memo', 'Memo')}</span>
        <MemoValue>{memo}</MemoValue>
      </MemoContainer>
      <MemoWarning>{t('wallet.memoWarning', 'NB! Not providing memo may result in loss of your assets')}</MemoWarning>
    </>
  )
}
